export default "__VITE_PUBLIC_ASSET__f57ae7e1__"